import { PaymentsModalType, SubscriptionDataModel } from "entities/shared/subscriptionModel";
import { useSearchQuery } from "./useSearchQuery";

const BULK_UPDATE_CACHE_KEY = "bulk-update-air-search-request";

export const useBulkUpdateSearchQuery = ({
  isAuthenticated,
  setSubscription,
  setActivePaymentModal,
  setAppIntegrationRequestLimitReached,
  setWebAppRequestLimitReached,
}: {
  isAuthenticated: boolean;
  setSubscription: (subscription: SubscriptionDataModel) => {
    type: string;
    payload: SubscriptionDataModel | null;
  };
  setActivePaymentModal: (activePaymentModal: PaymentsModalType) => {
    type: string;
    payload: PaymentsModalType | null;
  };
  setAppIntegrationRequestLimitReached: (appIntegrationRequestLimitReached: boolean) => {
    type: string;
    payload: boolean | null;
  };
  setWebAppRequestLimitReached: (webAppRequestLimitReached: boolean) => {
    type: string;
    payload: boolean | null;
  };
}): ReturnType<typeof useSearchQuery> => {
  return useSearchQuery({
    queryKey: [BULK_UPDATE_CACHE_KEY],
    isAuthenticated,
    setSubscription,
    setActivePaymentModal,
    setAppIntegrationRequestLimitReached,
    setWebAppRequestLimitReached,
  });
};
